module.exports = __webpack_public_path__ + "static/media/hamburger.6faca5de.svg";